// 案件列表页面翻译（新版本卡片样式）
export default {
  // 页面标题和版本切换
  pageTitle: "研判分析-案件分析",
  switchToOldVersion: "切到老版本",
  switchToNewVersion: "切到新版本",

  // 顶部操作区
  header: {
    updateTime: "更新时间",
    selectPlaceholder: "请选择",
    searchPlaceholder: "请输入{label}",
    createCase: "新建案件",
  },

  // 搜索类型选项
  searchTypes: {
    name: "案件名称",
    caseType: "案件类型",
    createUserName: "创建人",
  },

  // 卡片内容
  card: {
    edit: "编辑",
    delete: "删除",
    canvasCount: "[画布数量]",
    surveyUser: "[调证用户]",
    surveySuggests: "[调证建议]",
    updateTime: "更新时间",
    viewDetail: "查看详情",
  },

  // 底部分页
  footer: {
    total: "共计",
    totalUnit: "条记录",
  },

  // 确认对话框
  confirmDialog: {
    deleteTitle: "删除确认",
    deleteMessage: "此操作将永久删除{caseName}案件, 是否确定?",
    confirmButton: "确定",
    cancelButton: "取消",
  },

  // 消息提示
  messages: {
    deleteSuccess: "删除成功",
    deleteCancelled: "已取消删除",
  },
};
